<template>
  <div class="flex justify-center">
    <naan-one v-if="naanAmount === 1" />
    <naan-two v-if="naanAmount === 2" />
    <naan-three v-if="naanAmount === 3" />
    <naan-four v-if="naanAmount === 4" />
    <naan-five v-if="naanAmount >= 5" />
  </div>
</template>

<script>
import NaanOne from "@/components/ImageSvg/NaanOne";
import NaanTwo from "@/components/ImageSvg/NaanTwo";
import NaanThree from "@/components/ImageSvg/NaanThree";
import NaanFour from "@/components/ImageSvg/NaanFour";
import NaanFive from "@/components/ImageSvg/NaanFive";

export default {
  name: "NaanSvgComponent",
  components: { NaanOne, NaanTwo, NaanThree, NaanFour, NaanFive },
  props: {
    naanAmount: {
      type: Number
    }
  }
};
</script>
